module.exports = __webpack_public_path__ + "static/media/vehicle_stopped_moving.c951ad2f.svg";